module.exports = __webpack_public_path__ + "static/media/activity-speech-sound.b29db3ad.mp3";